import { action, observable, toJS } from "mobx";
import ViewModel from "../../../infrastructure/ViewModel";
import RouteList from "../../../infrastructure/RouteList";
import { ErrorModel } from "../../../infrastructure/ErrorModel";
import Utils from "../../../infrastructure/Utils";
import { AbstractValidator } from "fluent-ts-validator";
import {
  InviteAgentModel,
  LevelLookup,
  ReportingUpline,
  ReportingUplineResponse,
} from "../../../services/AgentManagementService";
import Collection from "../../../infrastructure/CollectionHelper";
import AgentManagementStore from "../../../store/AgentManagementStore";
import { AgentManagementViewModel } from "../AgentManagementViewModel";
import PageContext from "../../../infrastructure/PageContext";
import { toast } from "react-toastify";

export class InviteAgentViewModel implements ViewModel {
  private parentViewModel: AgentManagementViewModel;

    constructor(parentViewModel: AgentManagementViewModel) {
        this.parentViewModel = parentViewModel;
    }
  get CanClose(): boolean {
    throw new Error("Method not implemented.");
  }
  get CanRoute(): boolean {
    return true;
  }
  get IsLoaded(): boolean {
    throw new Error("Method not implemented.");
  }
  get IsLoading(): boolean {
    throw new Error("Method not implemented.");
  }
  Close(): void {
    throw new Error("Method not implemented.");
  }
  @action Load = async () => {
    this.levelLookup();
    this.resetInviteAgentForm();
  };
  @action onCloseDialog = (value: boolean) => {
    this.parentViewModel.setInviteAgentDialogVisibility(value);
  };
  Route = async (currentRoute: RouteList): Promise<void> => {alert("Route");this.levelLookup();};
  @observable public ErrorModelInviteAgent = new ErrorModel(
    new InviteAgentValidator()
  );
  @action
  public IsFormValid = async () => {
    return this.ErrorModelInviteAgent.IsFormValid(this);
  };
  @action
  public ValidateInviteAgent = async () => {
    return this.ErrorModelInviteAgent.Validate(this);
  };
  @observable FirstNameError: string = "";
  @observable LastNameError: string = "";
  @observable EmailError: string = "";
  @observable PhoneError: string = "";
  @observable FirstName: string = "";
  @observable firstNamePlaceHolder: string = "Enter first name";
  @observable LastName: string = "";
  @observable lastNamePlaceHolder: string = "Enter last name";
  @observable Email: string = "";
  @observable emailPlaceHolder: string = "Enter email address";
  @observable emailRegex: RegExp = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
  @observable PhoneNumber: string = "";
  @observable phoneNumberPlaceHolder: string = "Enter phone number";
  @observable AgentType: string = "";
  @observable AgentLevel:any = "";
  @observable AgentLevelId:any = "";
  @observable selectedeUpline: string = "";
  @observable selectedReportsTo: string = "0";
  @observable selectedUplineAgentId: string = "";
  @observable selectedeUplineNPN: string = "";
  @observable filteredUplineList = new Collection<ReportingUplineResponse>();

  @observable disableSave: boolean = true;
  @observable isNotValidAgent: boolean = false;

  @observable agentTypeList = [
    { label: "Individual", value: "3" },
    { label: "Business Entity", value: "4" },
    { label: "LOA", value: "1" },
  ];

  @observable agentLevelist = new Collection<LevelLookup>();;
 
  @observable reportsToList = new Collection<{
    label: string;
    value: string;
  }>();

  @observable isMessgeVisible: boolean = false;
  @observable response: any = "";
  @observable InviteAgentMessage:any;
  
  @observable isLoading: boolean = false;
  @observable nameAllowedRegex = /^[A-Za-z- '`‘’]+$/; // hyphen placed at end to avoid range issues
  @observable nameHasLetterRegex = /[A-Za-z]/;
  @observable tooShortMsg = (label: string) =>
    `${label} must be 2+ characters in length. Valid characters include A-Z. Space, hyphen, and apostrophe are the only special characters accepted.`;
  @observable tooLongMsg = (label: string) =>
    `${label} must be 50 characters or less`;
  @observable invalidCharsMsg = (label: string) =>
    `${label} must be 2+ characters in length. Valid characters include A-Z. Space, hyphen, and apostrophe are the only special characters accepted.`;
  @observable letterMsg = (label: string) =>
    `${label} must include at least one letter (A–Z).`;
  @observable requiredMsg = (label: string) => `${label} is required`;

  @action validateName = (value: string, label: string): string => {
    if (!value) return this.requiredMsg(label);
    if (value.length < 2) return this.tooShortMsg(label);
    if (value.length > 50) return this.tooLongMsg(label);
    if (!this.nameAllowedRegex.test(value)) return this.invalidCharsMsg(label);
    if (!this.nameHasLetterRegex.test(value)) return this.letterMsg(label);
    return '';
  };
  @action emailValidation(value: string) {
    if (!this.emailRegex.test(value)) {
      this.EmailError = "Invalid email address"
    } else {
      this.EmailError = "";
    }
    this.enableDisableSaveButton();
  };

  @action handleFirstName (value: string) {
    this.FirstNameError = this.validateName(value,"First Name");
    this.enableDisableSaveButton();
  };

  @action handleLastName (value: string) {
    this.LastNameError = this.validateName(value,"Last Name");
    this.enableDisableSaveButton();
  };

  @action phoneValidation(value: string) {
    //this.Email = value;
    this.PhoneNumber = this.formatPhoneNumber(value);
    if (this.PhoneNumber.length !== 13) {
      this.PhoneError = "Invalid phone number"
    } else {
      this.PhoneError = "";
    }
    this.enableDisableSaveButton();
  };

  @action formatPhoneNumber = (input: string) => {
    const digits = input.replace(/\D/g, '');
    if (!digits) {
      return '';
    }
    const limitedDigits = digits.slice(0, 10);
    if (limitedDigits.length <= 3) {
      return `(${limitedDigits}`;
    } else if (limitedDigits.length <= 6) {
      return `(${limitedDigits.slice(0, 3)})${limitedDigits.slice(3)}`;
    } else {
      return `(${limitedDigits.slice(0, 3)})${limitedDigits.slice(
        3,
        6
      )}-${limitedDigits.slice(6)}`;
    }
  };
  @action setFirstName(value: string) {
    this.FirstName = value
    this.enableDisableSaveButton();
  };
  @action setLastName(value: string) {
    this.LastName = value;
    this.enableDisableSaveButton();
  };
  @action setEmail(value: string) {
    this.Email = value;
    this.enableDisableSaveButton();
  };
  @action setPhoneNumber(value: string) {
    this.PhoneNumber = this.formatPhoneNumber(value);
    if (this.PhoneNumber.length === 13) {
      this.enableDisableSaveButton();
    } else {
      this.disableSave = true;
    }
  };
  @action setAgentType(value: string) {
    this.AgentType = value;
    this.enableDisableSaveButton();
  };

  @action setAgentLevel(value: string) {
    this.AgentLevel = value;
    this.enableDisableSaveButton();
  };

  @action setUpline(value: string) {
    this.selectedeUpline = value;
    if (!value) {
      this.setSelectedReportsTo("0");
    }
  }
  @action setSelectedReportsTo(value: string) {
    this.selectedReportsTo = value;
    //this.enableSave();
  }
  @action setUplineAgentId(value: string) {
    this.selectedUplineAgentId = value;
    this.enableDisableSaveButton();
  }
  @action setUplineNPN(value: string) {
    this.selectedeUplineNPN = value;
  }
  @action searchUpline = async (value: string) => {
    try {
      const result = await AgentManagementStore.upLineReporting(
        value,
      );
      this.loadReportsToList(result);
    } catch (e) {
      const noAgent: ReportingUplineResponse = { id: 0 };
      this.filteredUplineList.values = [noAgent];
    }
  };

  @action loadReportsToList = async (data?: ReportingUpline) => {
    if (data != null && data.recordCount > 0 && data.data.length > 0) {
      this.reportsToList.values = [];
      this.filteredUplineList.values = [...data.data]; 
      this.filteredUplineList.values.unshift({ id: -1 });
    } else {
      const noAgent: ReportingUplineResponse = { id: 0 };
      this.filteredUplineList.values = [noAgent];
    }
  };

  @action enableDisableSaveButton = async () => {
    if (!(await this.IsFormValid())) {
      if (this.EmailError !== "" || this.PhoneError !== "" || this.FirstNameError != "" || this.LastNameError != "") this.disableSave = true;
      else this.disableSave = false;
    } else {
      this.disableSave = true;
    }
  };

  @action levelLookup = async () => {
    try {
      const result = await AgentManagementStore.levelLookup();
      this.agentLevelist.values = Array.isArray(result) ? result : [result];
      const selectedLevel = this.agentLevelist.values.find(level => level.selected);
      if (selectedLevel && !this.AgentLevel) {
        this.AgentLevel = selectedLevel.value?selectedLevel.value:"";
      }
    } catch (e) {
      const noAgent: ReportingUplineResponse = { id: 0 };
      this.filteredUplineList.values = [noAgent];
    }
  };

   @action resetInviteAgentForm() {
    this.FirstNameError = "";
    this.LastNameError = "";
    this.EmailError = "";
    this.PhoneError = "";
    this.FirstName = "";
    this.LastName = "";
    this.Email = "";
    this.PhoneNumber = "";
    this.AgentType = "";
    this.AgentLevel = "";
    this.AgentLevelId = "";
    this.selectedeUpline = "";
    this.selectedReportsTo = "0";
    this.selectedUplineAgentId = "";
    this.selectedeUplineNPN = "";
    this.disableSave = true;
    this.isNotValidAgent = false;
    this.isMessgeVisible = false;
    this.response = "";
    this.isLoading = false;
    }
   
    @action inviteAgent = async () => {
      if (!this.disableSave) {
        this.isLoading = true;
        this.isMessgeVisible = false;
        this.disableSave = true;

        let _url = Utils.getServiceUrlByEnvironment()+"/api/contracting/v1/agentManagement/inviteAgent";
        const requestOptions = {
          method: 'POST',
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ 
            "firstName": this.FirstName,
            "lastName": this.LastName,
            "emailAddress": this.Email,
            "phoneNumber": this.PhoneNumber,
            "writingAgentTypeId": this.AgentType,
            "uplineAgentId":this.selectedUplineAgentId,
            "uplineNPN": this.selectedeUplineNPN,
            "level": this.AgentLevel,
            "levelId": this.AgentLevelId,
            "tenantName": Utils.getBUName()
          })
        };
        fetch(_url, requestOptions)
        .then(function(fetchresponse) {
            if(fetchresponse.ok) { return fetchresponse.json(); }
            return Promise.reject(fetchresponse);
        })
        .then(response => {
          this.isLoading = false;
          if(response && response.isSuccess==true) {
            toast.success(response.message, {className:"custom-toaster", autoClose:6000});
            /* Utils.showSuccessToaster(response.message, 7000); */
            this.resetInviteAgentForm();
            this.onCloseDialog(false); 
          } else {
            this.InviteAgentMessage.show({ life: 8000, closable: false, severity: 'error', detail: response.message });
            this.isMessgeVisible = true;
            this.disableSave = false;
          }
        })
        .catch(error => {
          console.log(error);
          if (error.status) {
            error.json().then((json: any) => {
              this.InviteAgentMessage.show({ life: 8000, closable: false, severity: 'error', detail: json.title });
            });
          } else {
            this.InviteAgentMessage.show({ life: 8000, closable: false, severity: 'error', detail: "An error occurred while processing your request. Please try again. If the issue persists, contact the service desk." });
          }
          this.isLoading = false;
          PageContext.setIsMessageVisible(false);
          PageContext.isBackgroundMessageDisable = true;
        });

        /*  try {
           var dto: InviteAgentModel = {
            firstName: this.FirstName,
            lastName: this.LastName,
            emailAddress: this.Email,
            phoneNumber: this.PhoneNumber,
            writingAgentType: this.AgentType,
            uplineAgentId:this.selectedUplineAgentId,
            uplineNPN: this.selectedeUplineNPN,
            levelId: this.AgentLevel,
            tenantName: Utils.getBUName(),
           };
   
           const response = await AgentManagementStore.inviteAgent(dto);
           this.isLoading = false;
           if (response) {
            Utils.showSuccessToaster("Invitation sent to Agent.", 7000);
            this.resetInviteAgentForm();
            this.onCloseDialog(false); 
           }else{
            let exceptionMsg = {
              status: 400,
              title: "Agent invite failed",
              errors: { "": [] },
            };
            this.response = JSON.stringify(exceptionMsg);
             this.isMessgeVisible = true;
             this.disableSave = false;
           }
           
         } catch (error:any) {
           const obj = JSON.parse(error.response)
           this.isLoading = false;
           PageContext.setIsMessageVisible(false);
           PageContext.isBackgroundMessageDisable = true;
           setTimeout(() => (PageContext.isMessageVisible = false), 100);
           setTimeout(() => {
             let exceptionMsg = {
              status: obj.status,
              title: obj.title,
              errors: { "": [] },
            };
            this.response = JSON.stringify(exceptionMsg);
             this.isMessgeVisible = true;
             this.disableSave = false;
           }, 100);
         } */
       }
     };
   
};

class InviteAgentValidator extends AbstractValidator<InviteAgentViewModel> {
  public constructor() {
    super();
    this.validateIfString((input) => input.FirstName)
      .isNotEmpty()
      .withFailureMessage("First Name is required");

    this.validateIfString(input => input.LastName)
      .isNotEmpty()
      .withFailureMessage("Last Name is required");

    this.validateIfString(input => input.Email)
      .isNotEmpty()
      .withFailureMessage("Email is required");

    this.validateIfString(input => input.PhoneNumber)
      .isNotEmpty()
      .withFailureMessage("Phone Number is required");

    this.validateIfString(input => input.AgentType)
      .isNotEmpty()
      .withFailureMessage("Agent Type is required");

    this.validateIfString(input => input.selectedeUpline)
      .isNotEmpty()
      .withFailureMessage("Upline is required");

      this.validateIfString(input => input.AgentLevel)
      .isNotEmpty()
      .withFailureMessage("Agent Level is required");

      this.validateIfString(input => input.selectedUplineAgentId)
      .isNotEmpty()
      .withFailureMessage("Selected Upline Agent ID is required");

  }
}